'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _LinearProgress = require('material-ui/LinearProgress');

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _PropertyHelper = require('../common/PropertyHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	color: _propTypes2.default.string,
	max: _propTypes2.default.number,
	min: _propTypes2.default.number,
	mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	style: _propTypes2.default.object,
	value: _propTypes2.default.number
};

var allowedProperties = Object.keys(propTypes);

var WMLinearProgress = function WMLinearProgress(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_LinearProgress2.default, (0, _PropertyHelper.filter)(props, allowedProperties))
	);
};

exports.default = WMLinearProgress;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMLinearProgress/index.js